import { reset_user } from '@/redux/auth';
import { set_loading } from '@/redux/realtime';
import { setHttpReqs } from '@/redux/slices/httpReqsSlice';
import store from '@/redux/store';
import axios, {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse,
  Method,
} from 'axios';
import { toast } from 'react-toastify';

const update_loading = (url: string, add: boolean) => {
  const loading = store.getState().realtime.loading;
  if (add === true) {
    store.dispatch(set_loading([...loading, url]));
  } else {
    store.dispatch(set_loading(loading.filter((item) => item !== url)));
  }
};

const update_http_reqs = (
  http_req: {
    method: Method;
    url: string;
  },
  add: boolean
) => {
  const http_reqs = store.getState().httpReqs;
  if (add === true) {
    store.dispatch(
      setHttpReqs([...http_reqs, `${http_req.method}:${http_req.url}`])
    );
  } else {
    store.dispatch(
      setHttpReqs(
        http_reqs.filter(
          (item) => item !== `${http_req.method}:${http_req.url}`
        )
      )
    );
  }
};

const config = (config: AxiosRequestConfig) => {
  const access_token = store.getState().auth.access_token;
  const agentAccessToken = store.getState().agentAccessToken;
  const admin_access_token = store.getState().auth.admin_access_token;
  if (access_token !== '') config.headers['Access-Token'] = access_token;
  if (agentAccessToken !== '')
    config.headers['Agent-Access-Token'] = agentAccessToken;
  if (admin_access_token !== '')
    config.headers['Admin-Access-Token'] = admin_access_token;
  return config;
};

const requestConfig = (request: AxiosRequestConfig) => {
  if (request.method && request.url)
    update_http_reqs({ method: request.method, url: request.url }, true);
  if (request.url) update_loading(request.url, true);
  return request;
};

const responseConfig = (response: AxiosResponse): Promise<any> => {
  if (response.config.method && response.config.url)
    update_http_reqs(
      { method: response.config.method, url: response.config.url },
      false
    );
  if (response.config.url) update_loading(response.config.url, false);
  return Promise.resolve({
    data: response.data,
  });
};

const error_config_laravel = (error: AxiosError) => error_config(error, false);
const error_config_go = (error: AxiosError) => error_config(error, true);

const error_config = (error: AxiosError, go_api: boolean) => {
  if (error.config.method && error.config.url)
    update_http_reqs(
      { method: error.config.method, url: error.config.url },
      false
    );
  if (error.config.url) update_loading(error.config.url, false);
  const status = error.response?.status;
  const message = go_api ? error.response?.data : error.response?.data.message;
  if (status === 401) {
    if (message === 'auth.user') {
      store.dispatch(reset_user());
      if (window.location.pathname !== '/login')
        window.location.href = '/login';
    }
    if (message === 'auth.agent') {
      if (window.location.pathname !== '/agent/login')
        window.location.href = '/agent/login';
    }
    if (message === 'auth.admin') {
      if (window.location.pathname !== '/control_panel/login')
        window.location.href = '/control_panel/login';
    }
  } else if (status !== 404) {
    if (
      ![
        'gfc_missing',
        'someone.applied',
        'editing',
        'satisfied',
        'stopped',
        'none',
      ].includes(message)
    )
      toast.error(message);
  }
  return Promise.reject(error);
};

const api_v1 = axios.create({
  baseURL:
    window.location.protocol === 'https:' &&
    process.env.REACT_APP_ENV === 'local'
      ? 'https://papa-api.test/'
      : process.env.REACT_APP_API_URL,
});
api_v1.interceptors.request.use(config);
api_v1.interceptors.request.use(requestConfig);
api_v1.interceptors.response.use(responseConfig, error_config_laravel);

const go_api_v1 = axios.create({
  baseURL: process.env.REACT_APP_GO_API_URL,
});
go_api_v1.interceptors.request.use(config);
go_api_v1.interceptors.request.use(requestConfig);
go_api_v1.interceptors.response.use(responseConfig, error_config_go);

export { api_v1, go_api_v1 };
